import React, { useState,  useRef, useCallback, useEffect,memo } from 'react'
import { Link , useHistory} from 'react-router-dom'
import { useTranslation } from 'react-i18next'
// import cookie from 'js-cookie'
import { Button, Alignment, Classes, Navbar, NavbarGroup, Popover, Position, Menu, MenuItem, MenuDivider } from '@blueprintjs/core'
/* CONTEXT */
// import { CoreContext } from '../../../contexts/coreContext'
/* CUSTOM HOOKS */
import useAlert from '../../../lib/useAlert'
import useWindowSize from '../../../lib/useWindowSize'
/* LIB FUNCTIONS */
import CONST from '../../../lib/constants'
/* COMPONENTS */
import BPOmnibar from '../../../components/BPOmnibar'
import BPDialog from '../../BPDialog'
import LanguageSelector from '../../LanguageSelector'
import BPDrawer from '../../BPDrawer'
import BPBadgeButton from 'components/BPBadgeButton'
/* PAGES */
import ResetPasswordForm from '../../../forms/ResetPasswordForm'
import ContractDetail from '../../../views/ContractDetail'
import OrderConfirmationDetail from '../../../views/OrderConfirmationDetail'
import DeliveryDetail from '../../../views/DeliveryDetail'
import InvoiceDetail from '../../../views/InvoiceDetail'
import BPMenu from '../../BPMenu'
import BPMenuMobile from '../../BPMenuMobile'
import BPToast from 'components/BPToast'
import { userHasMenu } from 'lib/userHasMenu'
import useStore from 'lib/useStore'
import {  logOutUserSelector, userSelector, useUserStore } from 'store/userInfo.store'

const BPHeader = () => {
  const {t,i18n} = useTranslation()
  // const { setCore } = useContext(CoreContext)
  // const context = useContext(CoreContext)
  // const user = context.core.user
  const currentUser = useUserStore(userSelector)
  const logOutUser = useUserStore(logOutUserSelector)
  const { storeState, countWaitingSupportRequests } = useStore()
  const size = useWindowSize()
  const history = useHistory();
  // const location = useLocation()
  // const path = location.pathname

  const { openAlert } = useAlert()
  const [search] = useState([])
  const [isOpen, setIsOpen] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [showMobileMenu, setShowMobileMenu] = useState(false)
  const [showModalContractDetail, setShowModalContractDetail] = useState(false)
  const [contractNo, setContractNo] = useState({})
  const [showModalOrderConfDetail, setShowModalOrderConfDetail] = useState(false)
  const [orderConfNo, setOrderConfNo] = useState({})
  const [showModalInvoiceDetail, setShowModalInvoiceDetail] = useState(false)
  const [invoiceNo, setInvoiceNo] = useState({})
  const [showModalDeliveryDetail, setShowModalDeliveryDetail] = useState(false)
  const [deliveryNo, setDeliveryNo] = useState({})
  const [activeMenuText, setActiveMenuText] = useState('')

  const refSubmit = useRef()
  const toastRef = useRef()
  /* global localStorage */
  const userMenus = JSON.parse(localStorage.getItem('menu'))
  // TODO
  // const activeMenu = userMenus && userMenus.find((menuItem) => {
  //   let menu = null
  //   if (menuItem.route === null && menuItem.items) {
  //     menuItem.items.forEach((subMenuItem) => {
  //       if (path === subMenuItem.route) {
  //         // console.log(subMenuItem)
  //         menu = subMenuItem
  //       }
  //     })
  //   } else {
  //     if (path === menuItem.route) menu = menuItem
  //   }
  //   return menu
  // })
  // console.log(activeMenu)

  const logout = () => {
    try {
      // setCore({ user: { isLoggedIn: false } })
      // cookie.remove('token')
      // cookie.remove('user')
      // cookie.remove('approvedInformingId')
      logOutUser()
    } catch (error) {
      openAlert('error', true, error.message)
    }
  }
  const cbLogout = useCallback(logout, [])

  const onAcceptModal = () => {
    refSubmit.current.click()
    // setShowModal(false)
  }

  const onCloseModal = () => {
    setShowModal(false)
  }
  const onCloseModalContractDetail = () => {
    setShowModalContractDetail(false)
  }
  const onCloseModalOrderConfDetail = () => {
    setShowModalOrderConfDetail(false)
  }
  const onCloseModalInvoiceDetail = () => {
    setShowModalInvoiceDetail(false)
  }
  const onCloseModalDeliveryDetail = () => {
    setShowModalDeliveryDetail(false)
  }

  const onMobileMenuClick = (prms) => {
    setShowMobileMenu(!prms.isClosedDrawer)
    // console.log(prms.activeMenu)
    setActiveMenuText(prms.activeMenu.name)
  }

  const handleSearchedItem = (item) => {
    setIsOpen(false)
    if (item.search_type === '1') {
      // open contract detail modal by search result
      setContractNo(item.id)
      setShowModalContractDetail(true)
    }
    if (item.search_type === '2') {
      // open order confirm detail modal by search result
      setOrderConfNo(item.pi_message)
      setShowModalOrderConfDetail(true)
    }
    if (item.search_type === '3') {
      // open invoice detail modal by search result
      setInvoiceNo(item.pi_message)
      setShowModalInvoiceDetail(true)
    }
    if (item.search_type === '4') {
      // open delivery detail modal by search result
      setDeliveryNo(item.pi_message)
      setShowModalDeliveryDetail(true)
    }
  }

  const windowEventListeners = () => {
    window.addEventListener('storage', (e) => {
      // console.log(e)
      if (e.key === 'menu' || e.key === 'pxm' || e.key === 'roles') {
        if (e.newValue !== e.oldValue || e.newValue === '') {
          localStorage.removeItem(e.key)
          logout()
        }
      }
    })
  }

  const windowRemoveEventListener = () => {
    window.removeEventListener('storage', (e) => {
      if (e.key === 'menu' || e.key === 'pxm' || e.key === 'roles') {
        localStorage.removeItem(e.key)
      }
    })
  }

  const cbWindowEventListeners = useCallback(windowEventListeners, [])
  const cbWindowRemoveEventListener = useCallback(windowRemoveEventListener, [])
  const cbCountWaitingSupportRequests = useCallback(countWaitingSupportRequests, [])
  useEffect(() => {
    cbWindowEventListeners()
    cbCountWaitingSupportRequests()
    return () => {
      cbWindowRemoveEventListener()
    }
  }, [cbWindowEventListeners, cbWindowRemoveEventListener, cbCountWaitingSupportRequests])

  return (
    <>
      <BPToast ref={toastRef} />
      <BPOmnibar
        name='ship_to'
        isOpen={isOpen}
        placeholder={t('search')}
        data={search}
        onItemSelect={(item) => {
          handleSearchedItem(item)
        }}
        onClose={() => setIsOpen(false)}
      />
      <BPDialog
        size='30'
        confirmButtonText={t('change_password')}
        title={t('change_password')}
        onClose={onCloseModal}
        onAccept={onAcceptModal}
        show={showModal}
      >
        <ResetPasswordForm
          afterAccept={() => {
            onCloseModal()
            toastRef.current.showMessage({ message: t('password_changed_successfully'), timeout: 3000 })
          }}
          ref={refSubmit}
        />
      </BPDialog>
      <BPDialog
        size='90'
        removeFooter
        title={t('page_title_contract_details')}
        onClose={onCloseModalContractDetail}
        onAccept={onCloseModalContractDetail}
        show={showModalContractDetail}
      >
        <ContractDetail documentNo={contractNo} />
      </BPDialog>
      <BPDialog
        size='90'
        removeFooter
        title={t('title_order_confirmation_detail')}
        onClose={onCloseModalOrderConfDetail}
        show={showModalOrderConfDetail}
      >
        <OrderConfirmationDetail documentNo={orderConfNo} />
      </BPDialog>
      <BPDialog
        size='90'
        removeFooter
        title={t('page_title_invoice_details')}
        onClose={onCloseModalInvoiceDetail}
        onAccept={onCloseModalInvoiceDetail}
        show={showModalInvoiceDetail}
      >
        <InvoiceDetail documentNo={invoiceNo} />
      </BPDialog>
      <BPDialog
        size='90'
        removeFooter
        title={t('page_title_delivery_details')}
        onClose={onCloseModalDeliveryDetail}
        onAccept={onCloseModalDeliveryDetail}
        show={showModalDeliveryDetail}
      >
        <DeliveryDetail documentNo={deliveryNo} />
      </BPDialog>
      {size.width < CONST.DESKTOP_ZOOM_SIZE && (
        <BPDrawer
          title='WebShop 2.0'
          size='250px'
          className='bp3-mobile-menu-drawer'
          show={showMobileMenu}
          position={Position.LEFT}
          onClose={() => setShowMobileMenu(false)}
          canOutsideClickClose
          canEscapeKeyClose
          isCloseButtonShown={false}
          removeFooter
          icon={<img src='img/logo/ROCHE_LOGO_36px_RGB_DIGITAL.png' alt='WebShop App' aria-roledescription='logo' />}
        >
          {/* <div className='page-logo'>
        <Link to='/' className='page-logo-link press-scale-down d-flex align-items-center position-relative'>
          <img src='img/logo/ROCHE_LOGO_36px_RGB_DIGITAL.png' style={{ height: '50px' }} alt='WebShop 2.0' aria-roledescription='logo' />
          <span className='page-logo-text mr-1 color-roche-blue'>WebShop 2.0</span>
        </Link>
      </div> */}
          <BPMenuMobile items={userMenus} onMobileMenuClick={onMobileMenuClick} />
        </BPDrawer>
      )}

      <header className='page-header' role='banner'>
        {/* <span style={{ fontWeight: 'bold', color: 'white' }}>{size.width}</span> */}
        {size.width >= CONST.DESKTOP_ZOOM_SIZE ? (
          <div className='width-mobile-auto align-items-center shadow-0 cursor-pointer'>
            <Link to='/' className='page-logo-link press-scale-down d-flex align-items-center position-relative p-2' replace>
              <img src='img/logo/rochewhitebg.svg' alt='WebShop App' aria-roledescription='logo' height='30px' />
            </Link>
          </div>
        ) : (
          <>
            <Button
              className={Classes.MINIMAL}
              icon={<i className='fas fa-bars text-white' style={{ fontSize: '22px' }} />}
              onClick={() => setShowMobileMenu(true)}
            />
            <span className='text-white' style={{ minWidth: '40%', fontSize: '1rem', paddingLeft: '0.5rem' }}>
              {t(activeMenuText)}
            </span>
          </>
        )}

        <div style={{ width: '100%' }}>
          <Navbar id='nvbar' fixedToTop={false} style={{ backgroundColor: 'transparent', boxShadow: 'none', padding: 0 }}>
            {size.width >= CONST.DESKTOP_ZOOM_SIZE && (
              <NavbarGroup align={Alignment.LEFT} className={`${userMenus?.length > 8 && 'admin-nav'}`}>
                <BPMenu items={userMenus} />
              </NavbarGroup>
            )}
            <NavbarGroup align={Alignment.RIGHT}>
              {process.env.REACT_APP_TARGET_ENV !== 'PROD' && 
              <div className="env-info">
                <span>{process.env.REACT_APP_TARGET_ENV}</span>
                <small>v.{process.env.REACT_APP_VERSION}</small>
              </div>
              }
              {userHasMenu(['order_confirmations', 'contract_list', 'antibody_contract_list', 'invoice', 'delivery']) && (
                <Button
                  className={Classes.MINIMAL}
                  icon={<i className='fas fa-search fa-lg text-white' />}
                  onClick={() => setIsOpen(true)}
                />
              )}
              <Link to='/supportRequests' replace>
                {storeState.waitingSupportsCount > 0 ? (
                  <BPBadgeButton
                    minimal={true}
                    badge={storeState.waitingSupportsCount}
                    icon={<i className='fas fa-headset fa-lg text-white' />}
                  />
                ) : (
                  <Button className={Classes.MINIMAL} icon={<i className='fas fa-headset fa-lg text-white' />} />
                )}
              </Link>
              <Popover
                content={
                  <Menu className='nvmenu'>
                    <LanguageSelector />
                  </Menu>
                }
                position={Position.BOTTOM}
              >
                <Button className={Classes.MINIMAL} icon={<i className='fas fa-flag fa-lg text-white' />} />
              </Popover>
              <Popover
                content={
                  <Menu>
                    <MenuItem icon='person' className={Classes.MINIMAL} text={currentUser?.fullname} textClassName='user-menu-item' />
                    <MenuDivider />
                    <MenuItem icon='key' text={t('change_password')} onClick={() => setShowModal(true)} />
                    <MenuDivider />
                    <MenuItem icon='label' text={t('processing_of_personal_data')} onClick={() => history.push('/processingOfPersonalData')} />
                    <MenuDivider />
                    <MenuItem icon="document" href={`${process.env.PUBLIC_URL}/assets/policy/ilgilikisibasvuruformu_${i18n.language==="tr"?"tr":"en"}.docx`} target="_blank" download={t('data_application_form')} text={t('data_application_form')} id="menu-item-link-header"/>
                    <MenuDivider />
                    <MenuItem icon='log-out' text={t('logout')} onClick={cbLogout} />
                  </Menu>
                }
                position={Position.BOTTOM}
              >
                <Button className={Classes.MINIMAL} icon={<i className='fas fa-user-cog fa-lg text-white' />} />
              </Popover>
            </NavbarGroup>
          </Navbar>
        </div>
      </header>
    </>
  )
}
export default memo(BPHeader)
